export const catalog = {
  notLoggedInMessage: {
    title: 'Todavía no tenés ningún objeto',
    body: 'Registrate y depositá tu primer objeto!',
  },
  noObjectsMessage: {
    body: 'No hay objetos en este catálogo',
  },
}

export const title = {}



// WEBPACK FOOTER //
// ./src/sections/catalog/text.js